import { css } from '@emotion/react'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { postVizionEmbedUrl } from 'src/state/ducks/vizionEmbedUrl/actions'
import { selectVizionEmbedUrl } from 'src/state/ducks/vizionEmbedUrl/selectors'
import { RootState } from 'src/state/store'
import { AnalyticsWrapper } from './AnalyticsWrapper'
import { useEmbedDashboard } from './hooks/useEmbedDashboard'

const errorStyle = css`
  color: white;
  background-color: red;
  padding: 10px;
  border-radius: 5px;
  margin: 10px;
`

const dashboardContainerStyle = css`
  width: 100%;
  height: calc(100vh - var(--banner-height, 0px));
  border: 0;
  box-sizing: border-box;
`

const noDataStyle = css`
  color: #333;
  background-color: #f0f0f0;
  padding: 15px;
  border-radius: 8px;
  margin: 20px 0;
  text-align: center;
`

const Analytics: React.FC = () => {
  const dispatch = useDispatch()
  const embedUrl = useSelector(selectVizionEmbedUrl)
  const loading = useSelector(
    (state: RootState) => state.vizionEmbedUrl.loading,
  )
  const error = useSelector((state: RootState) => state.vizionEmbedUrl.error)

  useEffect(() => {
    dispatch(postVizionEmbedUrl())
  }, [dispatch])

  const setDashboardRef = useEmbedDashboard(embedUrl)

  return (
    <AnalyticsWrapper>
      <div>
        {loading && <div>読み込み中...</div>}
        {error && (
          <div css={errorStyle}>ダッシュボードの取得に失敗しました。</div>
        )}
        {embedUrl && (
          <div ref={setDashboardRef} css={dashboardContainerStyle}></div>
        )}
        {!loading && !embedUrl && !error && (
          <div css={noDataStyle}>データがありません</div>
        )}
      </div>
    </AnalyticsWrapper>
  )
}

export default Analytics
